module.exports = __webpack_public_path__ + "static/media/main-goto-play.d3d69991.png";